import { EldsListView } from "./EldsListView";
import RouterOutlinedIcon from "@material-ui/icons/RouterOutlined";
import { EldCreate } from "./EldCreate";
import { EldEdit } from "./EldEdit";

export default {
  icon: RouterOutlinedIcon,
  list: EldsListView,
  create: EldCreate,
  edit: EldEdit,
};
